import React, { useState, useRef, useEffect } from 'react';
import { InputWarning } from '../../../components/inputwarning/input-warning.component';
import { useOnClickOutside } from 'usehooks-ts';

interface CustomDropdownProps {
  label?: string;
  value: string;
  options: { label: string; value: string }[];
  onChange: (value: string) => void;
  placeholder?: string;
  customClassName?: string;
  disable?: boolean;
}

export const CustomDropdown: React.FC<CustomDropdownProps> = ({
  label,
  value,
  options,
  onChange,
  placeholder,
  customClassName,
  disable,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openUpwards, setOpenUpwards] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      setOpenUpwards(spaceBelow < 150 && spaceAbove > spaceBelow);
    }
  }, [isOpen]);
  const ref = useRef(null);
  useOnClickOutside(ref, () => {
    setIsOpen(false);
  });
  return (
    <div
      className={`flex flex-col gap-1 relative ${isOpen ? 'z-30' : ''}`}
      ref={dropdownRef}
    >
      {label && (
        <label className="text-sm text-[#070708] flex items-center">
          {label}
          &nbsp;
          <InputWarning />
        </label>
      )}
      <div
        className={`border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-3  flex justify-between items-center ${customClassName} ${
          disable ? 'bg-[#ccc] cursor-not-allowed' : 'bg-white cursor-pointer'
        }`}
        onClick={() => {
          if (!disable) setIsOpen(!isOpen);
        }}
      >
        {options.find((option) => option.value === value)?.label ||
          placeholder ||
          ''}
        <span
          className={`transition-transform duration-300 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M19.5 9L12 16.5L4.5 9"
              stroke="#18191E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>

      {isOpen && (
        <ul
          ref={ref}
          className={`absolute z-30 max-h-72 overflow-y-auto bg-white border border-gray-300 w-full rounded-lg shadow-lg ${
            openUpwards ? 'bottom-full mb-1' : 'top-full mt-1'
          }`}
        >
          <div className="p-2 rounded-lg flex flex-col shadow-[0_4px_20px_#000000_0.1]">
            {options.map((option) => (
              <li
                key={option.value}
                className={`px-4 py-2 cursor-pointer text-base text-[#18191E] rounded-md bg-white hover:bg-[#F6F7F8] ${
                  value === option.value && 'bg-[#F6F7F8]'
                }`}
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
              >
                {option.label}
              </li>
            ))}
          </div>
        </ul>
      )}
    </div>
  );
};
